module.exports = __webpack_public_path__ + "img/sababida.61ea1a0a.png";